import React from 'react';
import { Button, Container, Group, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { removeLocalStorage } from '../storage/localStorage';
import BreakdownView from '../features/breakdown/BreakdownView';

const Dashboard = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    removeLocalStorage('authorization');
    navigate('/', { replace: true });
  };

  return (
    <Container size="xl" py="xl">
      <Group justify="space-between" mb="xl">
        <Title order={2}>Vendors usage dashboard</Title>
        <Button variant="default" onClick={handleLogout}>
          Sign out
        </Button>
      </Group>
      <BreakdownView />
    </Container>
  );
};

export default Dashboard;
